export const MAX_TITLE_LENGTH = 50
export const RECOMMENDED_TITLE_LENGTH = 30
